import { Card, Loader, SpacingMediumBottom } from '@mews-commander/ui';
import { Reservation } from '@mews-commander/data-access';
import { useCommanderSelector } from '@mews-commander/utils';
import { useAreReservationOrderItemsFetching } from '@mews-commander/core/entities';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { primitiveTypeUniq } from '@mews/fp';
import { areOrderItemsFetching, isReservationOverviewInitializing } from '../../../../selectors';
import { ReservationsOverviewContent } from './ReservationsOverviewContent';

interface Props {
    reservations: Reservation[];
    scope: string;
}
const ReservationsOverview: React.FC<Props> = ({ reservations, scope }) => {
    const uniqueServiceIds = primitiveTypeUniq(reservations.map((r) => r.serviceId));
    // @ts-expect-error
    const isFetchingTab = useCommanderSelector((s) => isReservationOverviewInitializing(s, { scope }));
    const isFetchingOrderItemsRedux = useCommanderSelector((s) => areOrderItemsFetching(s, { scope }));
    const isFetchingOrderItemsQuery = useAreReservationOrderItemsFetching(scope);
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const isFetchingOrderItems = isReservationModuleReactQueryEnabled
        ? isFetchingOrderItemsQuery
        : isFetchingOrderItemsRedux;
    if (isFetchingOrderItems || isFetchingTab) return <Loader />;

    return !uniqueServiceIds.length ? null : (
        <>
            {uniqueServiceIds.map((serviceId) => (
                <Card padding="0" key={serviceId}>
                    <ReservationsOverviewContent serviceId={serviceId} />
                    <SpacingMediumBottom />
                </Card>
            ))}
        </>
    );
};

export default ReservationsOverview;
